<template>
  <div class="app-container">
    <div class="video-link">
      <div class="banners-container">
        <pang-banner
          ref="videoBanner"
          :images="banners.videos"
          :interval="4000"
          :height="
            screenState.screenWidth < 767
              ? 'calc(880 / 750 * 100vw)'
              : 'calc(900 / 1920 * 100vw)'
          "
        />
      </div>
      <div
        class="play-butt-container"
        v-if="
          $refs.videoBanner &&
          $refs.videoBanner.offset !== undefined &&
          banners.videos.length > 0 &&
          banners.videos[$refs.videoBanner.offset] &&
          banners.videos[$refs.videoBanner.offset].video_url
        "
      >
        <div class="play-butt" @click="showVideo">
          <i><span></span></i>
        </div>
      </div>
      <div :class="isCollapse ? '' : 'video-footer'"></div>
    </div>
    <div :class="isCollapse ? '' : 'home-content'">
      <recent :banners="banners.banners" />
      <strategy />
      <news :maps="banners.maps" />
      <download />
    </div>
    <div
      class="video-play-container"
      :class="isCollapse ? 'video-collapse' : ''"
      v-if="playVideo"
    >
      <div>
        <i class="fa fa-times" @click="hideVideo"></i>
      </div>
      <iframe
        :width="screenState.screenWidth * 0.8"
        :height="screenState.screenWidth * 0.4"
        :src="video_url"
      >
      </iframe>
    </div>
    <transition name="fade">
      <div
        v-if="promotionShow"
        class="promotion"
        :class="isCollapse ? 'promotion-collapse' : ''"
      >
        <div class="close-butt">
          <img
            @click="closePromotion"
            src="../../assets/images/btn_close_suspension.png"
            alt=""
          />
        </div>
        <div @click="gotoPromotion" class="goto-butt"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import { PangBanner } from '../../components'
import { useScreenState } from '../../store'
import { Recent, Strategy, News, Download } from './components'
import request from '../../api/request'

export default {
  name: 'Home',
  components: {
    Recent,
    Strategy,
    News,
    Download,
    PangBanner
  },
  data() {
    return {
      playVideo: false,
      promotionShow: false,
      screenState: useScreenState(),
      staticUrl: request.staticUrl,
      video_url: '',
      banners: {
        videos: [],
        banners: [],
        maps: []
      }
    }
  },
  methods: {
    showVideo() {
      if (
        this.$refs.videoBanner &&
        this.$refs.videoBanner.offset !== undefined &&
        this.banners.videos.length > 0 &&
        this.banners.videos[this.$refs.videoBanner.offset]
      ) {
        this.playVideo = true
        this.video_url =
          this.banners.videos[this.$refs.videoBanner.offset].video_url || ''
      }
    },
    hideVideo() {
      this.playVideo = false
    },
    closePromotion() {
      this.promotionShow = false
    },
    gotoPromotion() {
      let url = '/recent/activity/194'
      this.$router.push(url)
    },
    getBanners() {
      let _this = this
      request
        .get('/banners', {
          limit: 9999999,
          banner_type__in: '1,2,6',
          ordering: 'id'
        })
        .then(function (res) {
          if (res.status == 200) {
            _this.banners = res.data.results.reduce(
              function (result, x) {
                if (x.banner_type == 1) {
                  result.videos.push(x)
                } else if (x.banner_type == 2) {
                  result.banners.push(x)
                } else if (x.banner_type == 6) {
                  result.maps.push(x)
                }
                return result
              },
              {
                videos: [],
                banners: [],
                maps: []
              }
            )
          }
        })
    }
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900
    }
  },
  mounted() {
    //   let _this = this
    //   request.get('/promocodes', {user__isnull: true, limit: 1}).then(function (res) {
    //       if (res.status == 200) {
    //         if (res.data.results.length > 0)
    //           _this.promotionShow = true
    //       }
    //   })
    this.getBanners()
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.home-content {
  background-image: url('~@/assets/images/bg_home.jpg');
  background-size: 100% 100%;
  width: 100vw;
  height: calc(3669 / 1920 * 100vw);
  /* background-position: 0% 90%; */
}

.video-link {
  background-size: 100% 100%;
  height: calc(900 / 1920 * 100vw);
  width: 100vw;
}

.video-footer {
  background-image: url('~@/assets/images/img_videofooter.png');
  background-size: 100% 100%;
  height: calc(137 / 1920 * 100vw);
  width: 100vw;
  z-index: 99;
  position: absolute;
  top: calc(763 / 1920 * 100vw);
}

@media only screen and (max-width: 767px) {
  .video-link {
    background-size: 100% 100%;
    padding-top: 0;
    height: calc(880 / 750 * 100vw);
    width: 100vw;
  }

  .play-butt {
    position: relative;
    left: 3vw;
    top: calc(880 / 750 * 100vw - 90vw);
    height: 24vw !important;
    width: 24vw !important;
    margin-left: auto !important;
  }
  .play-butt i span {
    display: none;
  }
}

.play-butt-container {
  padding-top: calc(420 / 1920 * 40vw);
}

.play-butt {
  background: url('~@/assets/images/btn_play02_home.png') no-repeat;
  background-size: 80% 80%;
  background-position: center;
  height: 6.5vw;
  width: 6.5vw;
  margin: auto;
  cursor: pointer;
  border-radius: 50%;
  border: 2px solid #370404;
  position: relative;
  margin-left: 62vw;
}
.play-butt i {
  height: 6.5vw;
  width: 6.5vw;
  position: absolute;
  /*旋转动画*/
  animation: circleRoate 2s infinite linear;
}
.play-butt i span {
  position: absolute;
  left: 6vw;
  top: 1.6vw;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffffff;
  border: 2px solid #370404;
}
@keyframes circleRoate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.video-play-container {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;
  z-index: 101;
  background-color: rgba(0, 0, 0, 0.68);
  padding-top: 15vh;
  text-align: center;
  font-size: 50px;
}

.video-play-container > div {
  text-align: right;
  margin-right: 5vw;
}

.video-play-container i {
  cursor: pointer;
}

.video-collapse {
  font-size: 5vw;
}
</style>

<style scoped>
.banners-container {
  position: absolute;
  width: 100vw;
}

.promotion {
  position: fixed;
  top: 70px;
  left: 40px;
  background: url('~@/assets/images/btn_suspension_home.png') no-repeat;
  height: 288px;
  width: 173px;
  z-index: 100;
}

.close-butt img {
  margin-top: 10px;
  margin-left: -25px;
  cursor: pointer;
}

.goto-butt {
  width: 140px;
  height: 30px;
  margin: 192px auto 0 auto;
  cursor: pointer;
}

.promotion-collapse {
  position: absolute;
  top: 0;
  left: calc(4.44vw + 4px);
  height: calc(32vw + 28.8px);
  width: calc(19.22vw + 17.3px);
  background-size: 100% 100%;
}

.promotion-collapse .close-butt img {
  margin-top: calc(1.11vw + 1px);
  margin-left: calc(-2.78vw - 2.5px);
  height: calc(3.56vw + 3.2px);
  width: calc(3.56vw + 3.2px);
}

.promotion-collapse .goto-butt {
  width: calc(15.56vw + 14px);
  height: calc(3.33vw + 3px);
  margin: calc(21.33vw + 19.2px) auto 0 auto;
}
</style>
